import React, { useMemo, useState } from 'react';
import { Select } from 'antd';
import { useQuery } from '@apollo/client';
import {
    GET_PRICING_FAILURE_CLIENTS_BY_SCENARIO,
    type GetPricingFailureClientsByScenarioResponse
} from '../graphql/queries/getPricingFailureClientsByScenario';

const { Option } = Select;

interface PricingFailureClientSugSelectorProps {
    businessScenarioCode?: number;
    value?: string | string[];
    onChange?: (value?: string | string[]) => void;
    placeholder?: string;
    disabled?: boolean;
    allowClear?: boolean;
    className?: string;
    mode?: 'single' | 'multiple';
}

export const PricingFailureClientSugSelector: React.FC<PricingFailureClientSugSelectorProps> = ({
    businessScenarioCode,
    value,
    onChange,
    placeholder = '请选择客户（默认空）',
    disabled = false,
    allowClear = true,
    className,
    mode = 'single'
}) => {
    const [searchText, setSearchText] = useState('');
    const isMultiple = mode === 'multiple';

    const { data, loading } = useQuery<GetPricingFailureClientsByScenarioResponse>(
        GET_PRICING_FAILURE_CLIENTS_BY_SCENARIO,
        {
            variables: businessScenarioCode ? { businessScenarioCode } : undefined,
            skip: !businessScenarioCode,
            fetchPolicy: 'network-only'
        }
    );

    const allOptions = data?.getPricingFailureClientsByScenario || [];

    const filteredOptions = useMemo(() => {
        if (!searchText.trim()) return allOptions;
        const kw = searchText.toLowerCase();
        return allOptions.filter((o) => o.label.toLowerCase().includes(kw) || o.value.toLowerCase().includes(kw));
    }, [allOptions, searchText]);

    return (
        <Select
            className={className}
            placeholder={placeholder}
            loading={loading}
            notFoundContent={loading ? 'Loading...' : 'No Customer'}
            showSearch
            filterOption={false}
            onSearch={setSearchText}
            onChange={(v) => {
                setSearchText('');
                onChange?.(v);
            }}
            allowClear={allowClear}
            onClear={() => {
                setSearchText('');
                onChange?.(isMultiple ? [] : undefined);
            }}
            disabled={disabled || !businessScenarioCode}
            value={value}
            mode={isMultiple ? 'multiple' : undefined}
            maxTagCount={isMultiple ? 'responsive' : undefined}
            dropdownStyle={{ maxHeight: 300, overflow: 'auto' }}
        >
            {filteredOptions.map((o) => (
                <Option key={o.value} value={o.value}>
                    {o.label}
                </Option>
            ))}
        </Select>
    );
};

